import { gql } from "@apollo/client";

// ==================== SELLER PROFILE QUERIES ====================

export const GET_SELLER_PROFILES = gql`
  query GetSellerProfiles {
    sellerProfiles {
      id
      businessName
      description
      businessType
      status
      logoImage
      images
      categories
      specialties
      contactEmail
      contactPhone
      address {
        street
        city
        state
        postcode
        country
      }
      isVerified
      isFeatured
      averageRating
      reviewCount
      offersDelivery
      offersPickup
      offersShipping
      yearsInBusiness
      madeByClient {
        id
        fName
        lName
      }
    }
  }
`;

export const GET_SELLER_PROFILE = gql`
  query GetSellerProfile($id: ID!) {
    sellerProfile(id: $id) {
      id
      businessName
      description
      businessType
      status
      logoImage
      images
      categories
      specialties
      contactEmail
      contactPhone
      address {
        street
        city
        state
        postcode
        country
        latitude
        longitude
      }
      socialMedia {
        website
        facebook
        instagram
        twitter
        linkedin
        youtube
        tiktok
      }
      businessHours {
        day
        openTime
        closeTime
        isClosed
      }
      aboutStory
      certifications
      yearsInBusiness
      isVerified
      isFeatured
      averageRating
      reviewCount
      minimumOrderAmount
      deliveryRadius
      offersDelivery
      offersPickup
      offersShipping
      madeByClient {
        id
        fName
        lName
        email
      }
      allowedEditorsClients {
        id
        fName
        lName
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_PUBLIC_SELLER_PROFILES = gql`
  query GetPublicSellerProfiles($tenantId: ID) {
    publicSellerProfiles(tenantId: $tenantId) {
      id
      businessName
      description
      businessType
      status
      logoImage
      images
      categories
      specialties
      contactEmail
      contactPhone
      address {
        street
        city
        state
        postcode
        country
      }
      isVerified
      isFeatured
      averageRating
      reviewCount
      offersDelivery
      offersPickup
      offersShipping
      yearsInBusiness
      madeByClient {
        id
        fName
        lName
      }
    }
  }
`;

export const GET_MY_SELLER_PROFILES = gql`
  query GetMySellerProfiles {
    mySellerProfiles {
      id
      businessName
      description
      businessType
      logoImage
      isVerified
      isFeatured
    }
  }
`;

export const GET_SELLER_PROFILES_BY_CLIENT = gql`
  query GetSellerProfilesByClient($clientId: ID!) {
    sellerProfilesByClient(clientId: $clientId) {
      id
      businessName
      description
      businessType
      logoImage
      isVerified
      isFeatured
      contactEmail
      contactPhone
      offersDelivery
      offersPickup
      offersShipping
    }
  }
`;

export const GET_SELLER_PROFILE_STATS = gql`
  query GetSellerProfileStats {
    sellerProfileStats
  }
`;

export const GET_CLIENTS = gql`
  query GetClients {
    clients {
      id
      fName
      lName
      email
    }
  }
`;

// ==================== SELLER PROFILE MUTATIONS ====================

export const CREATE_SELLER_PROFILE = gql`
  mutation CreateSellerProfile($input: SellerProfileInput!) {
    createSellerProfile(input: $input) {
      id
      businessName
      description
      businessType
      status
    }
  }
`;

export const UPDATE_SELLER_PROFILE = gql`
  mutation UpdateSellerProfile($id: ID!, $input: UpdateSellerProfileInput!) {
    updateSellerProfile(id: $id, input: $input) {
      id
      businessName
      description
      businessType
      status
      logoImage
      images
      categories
      specialties
      contactEmail
      contactPhone
      address {
        street
        city
        state
        postcode
        country
      }
      socialMedia {
        website
        facebook
        instagram
        twitter
        linkedin
        youtube
        tiktok
      }
      businessHours {
        day
        openTime
        closeTime
        isClosed
      }
      aboutStory
      certifications
      yearsInBusiness
      minimumOrderAmount
      deliveryRadius
      offersDelivery
      offersPickup
      offersShipping
      allowedEditorsClients {
        id
        fName
        lName
        email
      }
    }
  }
`;

export const DELETE_SELLER_PROFILE = gql`
  mutation DeleteSellerProfile($id: ID!) {
    deleteSellerProfile(id: $id)
  }
`;

export const UPDATE_SELLER_PROFILE_STATUS = gql`
  mutation UpdateSellerProfileStatus($id: ID!, $status: SellerProfileStatus!) {
    updateSellerProfileStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

// ==================== FILE UPLOAD MUTATIONS ====================

export const UPLOAD_UNENCRYPTED_FILE = gql`
  mutation UploadUnencrypted($file: Upload!) {
    uploadUnencryptedFile(file: $file)
  }
`;
